import TerminosPanel from '@/components/settings/terminos/TerminosPanel';

export default function TerminosPage() {
  return <TerminosPanel />;
}
